export const fontFamilies = {
  'apercu-mono':
    'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  'apercu-pro': 'sidecarta-sans, sans-serif',
  'apercu-pro-bold': 'sidecarta-sans-bold, sans-serif',
  'miller-text': 'sidecarta-sans-semibold, sans-serif',
  serif: 'georgia, serif',
  'sans-serif': 'helvetica, sans-serif',
}

export const fontWeights = {
  regular: 400,
  semibold: 600,
  bold: 700,
}

export const fontSizes = {
  // will deprecate soon
  caption: '0.75rem',
  sm: '0.875rem',
  md: '1.125rem',
  mdm: '1.25rem',
  // lg serves as both the desktop
  // h4 and mobile h3 font size
  lg: '1.5rem',
  lgm: '1.75rem',
  xl: '2rem',
  xlm: '2.25rem',
  '2xl': '3rem',
  '3xl': '4rem',

  // use below tokens for font sizes
  12: '0.75rem',
  14: '0.875rem',
  15: '0.9375rem',
  16: '1.0625rem',
  17: '1.0625rem',
  18: '1.125rem',
  20: '1.25rem',
  22: '1.375rem',
  24: '1.5rem',
  28: '1.75rem',
  32: '2rem',
  34: '2.125rem',
  36: '2.25rem',
  40: '2.5rem',
  42: '2.625rem',
  48: '3rem',
  56: '3.5rem',
  64: '4rem',
}

export const lineHeights = {
  // will deprecate soon
  caption: '1.0625rem',
  default: '1.5rem',
  sm: '0.875rem',
  md: '2rem',
  mdm: '2.5rem',
  lg: '3rem',
  xl: '3.5rem',
  '2xl': '4.5rem',

  // use below tokens for line heights
  16: '1.0625rem',
  20: '1.25rem',
  22: '1.375rem',
  24: '1.5rem',
  25: '1.5625rem',
  28: '1.75rem',
  32: '2rem',
  34: '2.125rem',
  36: '2.25rem',
  40: '2.5rem',
  41: '2.5625rem',
  48: '3rem',
  52: '3.1875rem',
  56: '3.5rem',
  64: '4rem',
  72: '4.5rem',
}
